import {useDispatch, useSelector} from "react-redux";

import React, {useEffect} from "react";
import {setBackgroundVideoLoopCurrentImageMapId, setBackgroundVideoLoopState} from "../exhibition_actions";
import {VelocityTransitionGroup} from "velocity-react";
import ImageMap from 'virtual_congress/components/image_map'
import {useParams, useHistory, useLocation,} from "react-router-dom"
import useMobile from "../effects/use_mobile";
import {ImageMapProvider} from "../components/image_map_provider";

require('velocity-animate');
require('velocity-animate/velocity.ui');

const Transition = (props) => {
  if (props?.disableTransition) {
    return (
      <div key={props.id}>
        {props.children}
      </div>
    );
  }
  return (
    <VelocityTransitionGroup component="div" enter={{animation: "fadeIn"}} leave={{delay: 50, animation: "fadeOut"}}>
      <div key={props.id}>
        {props.children}
      </div>
    </VelocityTransitionGroup>
  );
}

const RenderedImageMap = ({imageMapId, AddonRenderer}) => {
  const dispatch = useDispatch()
  const history = useHistory();
  const location = useLocation();

  const currentImageMapId = useSelector((state) => state.backgroundVideoLoop?.currentImageMapId)
  const imageMaps = useSelector((state) => state.imageMaps)
  const imageMapConfigs = useSelector((state) => state.imageMapConfigs)
  const imageHotspotConfigs = useSelector((state) => state.imageHotspotConfigs)
  const imageHotspots = useSelector((state) => state.imageHotspots)
  const videoState = useSelector(state => state.backgroundVideoLoop?.state)
  const {preselectedHotspotIdentifierParam, preselectedHotspotIdParam} = useParams();
  const {isMobile} = useMobile()
  const imageMap = imageMaps.find((img) => img.id == (isMobile ? imageMapId : (currentImageMapId || imageMapId)))
  const mapConfig = imageMapConfigs.find((imc) => imc.id == imageMap?.image_map_config_id)

  useEffect(() => {
    if (!isMobile && currentImageMapId != imageMapId) {
      if (!videoState || videoState == "outro_finished") {
        dispatch(setBackgroundVideoLoopState(null));
        dispatch(setBackgroundVideoLoopCurrentImageMapId(imageMapId))
      } else if (videoState != "outro") {
        dispatch(setBackgroundVideoLoopState("outro"));
      }
    } else {
      //dispatch(setBackgroundVideoLoopState("outro_finished"));
    }
  }, [currentImageMapId, imageMapId, videoState])

  useEffect(() => {
    // This otherwise if component is complete unloaded eg switching route from "/" to "/image_map/1",
    // then the loop state might be still in outro or smth. because user pressed back or so.
    return () => {
      dispatch(setBackgroundVideoLoopState("outro_finished"));
    }
  }, [])

  if (imageMap == null) {
    return <div className="alert alert-danger">
      No Map with this ID found
    </div>;
  }

  let preselectedHotspot = null
  let preselectedImageHotspotConfig = null
  if (preselectedHotspotIdentifierParam) {
    preselectedImageHotspotConfig = imageHotspotConfigs.find((ihc) => ihc.identifier == preselectedHotspotIdentifierParam)
    preselectedHotspot = imageHotspots.find((ih) => ih.image_hotspot_config_id == preselectedImageHotspotConfig?.id && ih.image_map_id == imageMap.id)
  } else if (preselectedHotspotIdParam) {
    preselectedHotspot = imageHotspots.find((ih) => ih.id == preselectedHotspotIdParam) // && ih.image_map_id == imageMap.id)
  }

  return <ImageMapProvider imageMap={imageMap}>
    <Transition disableTransition={imageMap?.config_data?.disable_transition} id={imageMap.id}>
      <ImageMap preselectedHotspot={preselectedHotspot} imageMap={imageMap}/>
      {AddonRenderer && <AddonRenderer preselectedHotspot={preselectedHotspot} imageMap={imageMap}/>}
    </Transition>
  </ImageMapProvider>;
}

export default RenderedImageMap
